export default __webpack_public_path__ + "static/spotify.url-a29fab1bb3d23b15c1972c394039c2c5.svg";